import { gsap, ScrollTrigger } from '@/plugins/gsap';
import { useMotion } from './useMotion';

// Scroll reveal for everything marked [data-reveal] inside `rootRef`.
// Elements rise into place and fade in, in viewport order, on a long expo ease so they settle
// softly. Distances scale with the screen: 18px on phones, 26px on tablets, 36px on desktop,
// so small screens never feel jumpy. Elements that start on screen reveal at once; the rest
// as they scroll in. Without motion (prefers-reduced-motion) they simply render in place.
export function useReveal(rootRef, { duration = 0.9, stagger = 0.08 } = {}) {
  useMotion(rootRef, (root) => {
    const items = gsap.utils.toArray('[data-reveal]', root);
    if (!items.length) return undefined;

    const w = window.innerWidth;
    const y = w < 640 ? 18 : w < 1024 ? 26 : 36;

    root.classList.add('sec-motion');
    gsap.set(items, { autoAlpha: 0, y });

    ScrollTrigger.batch(items, {
      start: 'top 90%',
      once: true,
      batchMax: 6,
      onEnter: (batch) =>
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          duration,
          stagger,
          ease: 'expo.out',
          overwrite: true,
          clearProps: 'transform',
        }),
    });

    return () => root.classList.remove('sec-motion');
  });
}
